import { render } from "./SvfTab.vue?vue&type=template&id=6ae20bc0&scoped=true"
import script from "./SvfTab.vue?vue&type=script&lang=js"
export * from "./SvfTab.vue?vue&type=script&lang=js"

import "./SvfTab.vue?vue&type=style&index=0&id=6ae20bc0&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae20bc0"]])

export default __exports__